import * as React from 'react';

export function getBrowserVisibilityProp() {
    if (typeof global.document.hidden !== 'undefined') {
        // Opera 12.10 and Firefox 18 and later support
        return 'visibilitychange';
        //@ts-ignore
    } else if (typeof global.document.msHidden !== 'undefined') {
        return 'msvisibilitychange';
        //@ts-ignore
    } else if (typeof global.document.webkitHidden !== 'undefined') {
        return 'webkitvisibilitychange';
    }

    // fallback
    return 'visibilitychange';
}

export function getBrowserDocumentHiddenProp() {
    if (typeof global.document.hidden !== 'undefined') {
        return 'hidden';
        //@ts-ignore
    } else if (typeof global.document.msHidden !== 'undefined') {
        return 'msHidden';
        //@ts-ignore
    } else if (typeof global.document.webkitHidden !== 'undefined') {
        return 'webkitHidden';
    }

    // fallback
    return 'hidden';
}

export function getIsDocumentHidden() {
    const hiddenPropName = getBrowserDocumentHiddenProp();

    //@ts-ignore
    return !global.document[hiddenPropName];
}

export function usePageVisibility() {
    // global.window as is it works only witihin client code
    const [isVisible, setIsVisible] = React.useState(global.window && getIsDocumentHidden());
    const onVisibilityChange = () => setIsVisible(global.window && getIsDocumentHidden());

    React.useEffect(() => {
        const visibilityChange = global.window && getBrowserVisibilityProp();

        global.document.addEventListener(visibilityChange, onVisibilityChange, false);

        return () => {
            global.document.removeEventListener(visibilityChange, onVisibilityChange);
        };
    });

    return isVisible;
}
